const testConfig = {
  baseUrl: 'https://test-api.dimorder.com',
};

export default testConfig;
